import React, { useEffect, useState, useCallback } from 'react';
import { Spin, Switch } from 'antd';
import { useAppDispatch } from '../../store/hooks';
import { isEnabledAds, getSettings, isMaintenanceMode } from '../../store/slices/userSlice';

const SettingsComp: React.FC = () => {
  const dispatch = useAppDispatch();

  // Local state
  const [loading, setLoading] = useState(true);
  const [isEnabledAdsState, setIsEnabledAdsState] = useState(false);
  const [isMaintenanceModeState, setIsMaintenanceModeState] = useState(false);

  // Fetch settings on mount
  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      try {
        const action = await dispatch(getSettings());
        const settingData = action.payload as Array<{ isTopSportEnabled?: boolean; isMaintenanceMode?: boolean }> | undefined;
        if (settingData && settingData.length > 0) {
          setIsEnabledAdsState(settingData[0]?.isTopSportEnabled || false);
          setIsMaintenanceModeState(settingData[0]?.isMaintenanceMode || false);
        }
      } catch {
        // Settings fetch failed - default values will be used
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, [dispatch]);

  // Handlers
  const handleAdsToggle = useCallback((checked: boolean) => {
    setIsEnabledAdsState(checked);
    dispatch(isEnabledAds({ isTopSportEnabled: checked }));
  }, [dispatch]);

  const handleMaintenanceToggle = useCallback((checked: boolean) => {
    setIsMaintenanceModeState(checked);
    dispatch(isMaintenanceMode({ isMaintenanceMode: checked }));
  }, [dispatch]);

  // Settings items configuration
  const settingsItems = [
    { label: 'Enable Top Sports Ads', checked: isEnabledAdsState, onChange: handleAdsToggle },
    { label: 'Maintenance Mode', checked: isMaintenanceModeState, onChange: handleMaintenanceToggle },
  ];

  return (
    <>
      <h2 className="page-heading">Settings</h2>
      <div className="box box-default mb-4">
        <Spin spinning={loading} delay={500}>
          {settingsItems.map(({ label, checked, onChange }) => (
            <div
              key={label}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                padding: '10px',
              }}
            >
              <p>{label}</p>
              <Switch checked={checked} onChange={onChange} />
            </div>
          ))}
        </Spin>
      </div>
    </>
  );
};

export default SettingsComp;



